import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram } from 'react-icons/fa'; // Import react-icons

// Updated SocialIcon to use react-icons and add aria-label
const SocialIcon = ({ href, icon: IconComponent, label }) => (
  <a 
    href={href} 
    target="_blank" 
    rel="noopener noreferrer" 
    aria-label={label} // Added aria-label
    className="text-brand-off-white hover:text-brand-green-light transition-colors duration-300 text-2xl"
  >
    <IconComponent />
  </a>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-green-dark text-brand-off-white py-12 md:py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {/* Column 1: About/Brand */}
        <div className="lg:col-span-1">
          <h5 className="text-xl font-semibold mb-4 text-brand-green-light">Quality Air Houston</h5>
          <p className="text-sm mb-4">
            Your trusted experts for HVAC installation, repair, and maintenance in the Greater Texas area.
          </p>
          {/* Social Media Icons */}
          <div className="flex space-x-4 mt-4">
            <SocialIcon href="#" icon={FaFacebookF} label="Facebook" />
            <SocialIcon href="#" icon={FaTwitter} label="Twitter" />
            <SocialIcon href="#" icon={FaInstagram} label="Instagram" />
            {/* Add more social icons as needed */}
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div>
          <h5 className="text-lg font-semibold mb-4 text-brand-green-light">Quick Links</h5>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-brand-green-light transition-colors duration-300">Home</Link></li>
            <li><Link to="/services" className="hover:text-brand-green-light transition-colors duration-300">Our Services</Link></li>
            <li><Link to="/about" className="hover:text-brand-green-light transition-colors duration-300">About Us</Link></li>
            <li><Link to="/testimonials" className="hover:text-brand-green-light transition-colors duration-300">Testimonials</Link></li>
            <li><Link to="/blog" className="hover:text-brand-green-light transition-colors duration-300">HVAC Blog</Link></li>
            <li><Link to="/contact" className="hover:text-brand-green-light transition-colors duration-300">Contact Us</Link></li>
          </ul>
        </div>

        {/* Column 3: Contact Information */}
        <div>
          <h5 className="text-lg font-semibold mb-4 text-brand-green-light">Get In Touch</h5>
          <address className="text-sm not-italic space-y-2">
            <p>6023 Pennworth Ln, Houston, TX 77084</p>
            <p>
              Phone: <a href="tel:+17139225702" className="hover:text-brand-green-light transition-colors duration-300">(713) 922-5702</a>
            </p>
            <p>
              Email: <a href="mailto:pejmanansaripoor@gmail.com" className="hover:text-brand-green-light transition-colors duration-300">pejmanansaripoor@gmail.com</a>
            </p>
            <p className="font-semibold">Emergency Service: 24/7 Available</p>
          </address>
        </div>

        {/* Column 4: Legal/Misc */}
        <div>
          <h5 className="text-lg font-semibold mb-4 text-brand-green-light">Resources</h5>
          <ul className="text-sm space-y-2">
            <li><Link to="/privacy-policy" className="hover:text-brand-green-light transition-colors duration-300">Privacy Policy</Link></li>
            <li><Link to="/terms-of-service" className="hover:text-brand-green-light transition-colors duration-300">Terms of Service</Link></li>
            <li><Link to="/sitemap" className="hover:text-brand-green-light transition-colors duration-300">Sitemap</Link></li>
          </ul>
        </div>
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center border-t border-brand-green-medium pt-8 mt-10">
        <p className="text-xs">
          &copy; {currentYear} Quality Air Houston. All Rights Reserved. Website by Mehranoffline@gmail.com
        </p>
      </div>
    </footer>
  );
};

export default Footer; 